<template>
<v-layout row class="align-center layout pl-3 pt-4 app--page-header">
    <div class="page-header-left">
        <v-breadcrumbs divider="-" :items="breadcrumbs">
            <template v-slot:item="props">
                <v-breadcrumbs-item :href="props.item.href" :class="[props.item.disabled && 'disabled']">
                    <h3>{{ props.item.text }}</h3>
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <template v-if="breadcrumbs.length == 0">
            <v-breadcrumbs>
                <v-breadcrumbs-item>
                    <h3>{{ routeName }}</h3>
                </v-breadcrumbs-item>
            </v-breadcrumbs>
        </template>
    </div>
    <v-spacer></v-spacer>
    <div class="page-header-right pr-3">
        <v-btn small v-if="$route.meta.otherButton && !options.invisibleOtherButton" @click="otherAction">
            <v-icon>{{$route.meta.otherButtonIcon ? $route.meta.otherButtonIcon : ''}}</v-icon>  {{$route.meta.otherButtonText ? $route.meta.otherButtonText : 'Log'}}
        </v-btn>
        <v-btn small v-if="$route.meta.createButton && !options.invisibleCreateButton" @click="createData" v-shortkey.once="['ctrl', 'n']" @shortkey="createData">
            <v-icon color="#dc3545">{{$route.meta.createButtonIcon ? $route.meta.createButtonIcon : 'add'}}</v-icon>  {{$route.meta.createButtonText ? $route.meta.createButtonText : 'ADD'}}
        </v-btn>
        <v-btn small v-if="$route.meta.saveButton && !options.invisibleSaveButton" @click="saveData" v-shortkey.once="['ctrl', 's']" @shortkey="saveData">
            <v-icon color="#dc3545">{{$route.meta.saveButtonIcon ? $route.meta.saveButtonIcon : 'save'}}</v-icon>  {{$route.meta.saveButtonText ? $route.meta.saveButtonText : 'SAVE'}}
        </v-btn>
        <v-btn small v-if="$route.meta.refreshButton" @click="refreshData" v-shortkey.once="['f5']" @shortkey="refreshData">
            <v-icon class="text--secondary">refresh</v-icon>  REFRESH
        </v-btn>
        <v-btn small v-if="$route.meta.deleteButton" @click="deleteData" v-shortkey.once="['alt','d']" @shortkey="deleteData">
            <v-icon class="text--secondary">delete</v-icon>
        </v-btn>
    </div>
</v-layout>
</template>

<script>
import menu from "@/api/menu";
import paths from "@/router/paths";
import configs from "@/configs";
import {
    buildBreadcrumb
} from "@/commons/utils";
export default {
     data() {
        return {
            options: {}
        }
     },
    computed: {
        routeName() {
            var title = this.$route.params.title ? this.$route.params.title : this.$route.meta.title;
            return title ? title : this.$route.name;
        },
        breadcrumbs: function () {
            let breadcrumbs = [];
            let routeName = this.$route.name;
            breadcrumbs = buildBreadcrumb(routeName, this.$route.path, this.$route.params.Pid, this.$route.params.title, menu, paths);
            return breadcrumbs;
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        }
    },
    methods: {
        otherAction() {
            window.getApp.$emit('OTHER_ACTION');
        },
        saveData() {
            window.getApp.$emit('PRE_SAVE_DATA');
        },
        createData() {
          this.$root.$emit('REQUEST_CREATE_DATA');
        },
        refreshData() {
          this.$root.$emit('REQUEST_REFRESH_DATA');
        },
        deleteData() {
            if(!this.adminRole) {
                sendErrorNotice("Bạn không có quyền thực hiện thao tác!");
                return;
            }
            this.$root.$emit('PRE_BULK_DELETE');
        },
        changeOption(options) {
            this.options = options;
        }
    },
    mounted() {
        this.$root.$on("REQUEST_ROOT_OPTION", this.changeOption);
    }
};
</script>
